enum TranslationType {
    Automatic = 0,
    Suggestion = 1,
    Manual = 2,
    None = 100,
}

export default TranslationType;
